<template id="UserMessage">
    <section class="interstitial-steps-sections">
        <div class="interstitial-steps-wrapper message-step">
            <h2 class="h2--secondary">{{ heading }}</h2>
            <h3 v-if="subHeading" class="h3--secondary">{{ subHeading }}</h3>

            <div class="interstitial_button">
                <a
                    class="button primary"
                    :class="primaryButton.class"
                    :href="primaryButton.link"
                    v-on="
                        primaryButton.role === 'SIGNOUT'
                            ? { click: gotToSignOut }
                            : {}
                    "
                >
                    <span class="button__text">{{ primaryButton.label }}</span>
                </a>
            </div>
            <div v-if="secondaryButton" class="interstitial_button">
                <a class="button secondary" :href="secondaryButton.link">
                    <span class="button__text">{{
                        secondaryButton.label
                    }}</span>
                </a>
            </div>
        </div>
    </section>
</template>

<script>
    import isEmpty from 'lodash/isEmpty';
    import UserMenu from 'components/userMenu';

    export default {
        name: 'user-message',
        methods: {
            gotToFAQ() {
                this.$trackingService.trackAction(this.trackActionName.FAQ);
                window.open(
                    this.pageAttribute.get('ap_help_faq_url'),
                    '_blank'
                );
            },
            gotToSignOut() {
                this.$trackingService.trackAction(
                    this.trackActionName.SIGN_OUT
                );
                let userMenu = new UserMenu();
                this.isProcessing = true;
                //@TODO: do not initialize AuthSuite for D2C users PPLUSINTL-4333
                if (
                    this.accessStatus &&
                    !isEmpty(this.accessStatus.accessMethodsInUse)
                ) {
                    userMenu.logoutWithAuthSuite(this.authorizationService);
                } else {
                    userMenu.logout();
                }
            }
        },
        props: {
            heading: {
                type: String,
                default() {
                    return this.$getLocale('oops_something_went_wrong');
                }
            },
            subHeading: String,
            primaryButton: {
                type: Object,
                default() {
                    return {
                        label: this.$getLocale('close'),
                        link: '/'
                    };
                }
            },
            secondaryButton: {
                type: Object,
                label: String,
                link: String
            }
        }
    };
</script>
